import { BasicContainer } from '@/components/Common/BasicContainer/BasicContainer';
import FormItem from '@/components/Common/FormItem/FormItem';
import { FormSectionTitle } from '@/components/Form/FormSectionTitle/FormSectionTitle';
import { Button, Grid, OutlinedInput, Stack } from '@mui/material';
import { useSellerContactDataViewController } from './SellerContactDataViewController';

export function SellerContactData() {
  const { uiState, actions } = useSellerContactDataViewController();

  return (
    <Stack spacing={'12px'} p={{ xs: '16px', md: '0px' }}>
      <FormSectionTitle title={'Datos de Contacto'} />
      <BasicContainer
        content={
          <Grid container columnSpacing={'20px'} p={'16px'}>
            <Grid size={12}>
              <FormItem
                label="Nombre Completo"
                helperText={uiState.fullNameError}
              >
                <OutlinedInput
                  fullWidth
                  value={uiState.fullName}
                  onChange={(e) => actions.onNameChanged(e.target.value)}
                  error={!!uiState.fullNameError}
                />
              </FormItem>
            </Grid>
            <Grid size={{ xs: 12, md: 6 }}>
              <FormItem
                label="Número de teléfono"
                helperText={uiState.phoneError}
              >
                <OutlinedInput
                  fullWidth
                  value={uiState.phone}
                  onChange={(e) => actions.onPhoneChanged(e.target.value)}
                  error={!!uiState.phoneError}
                />
              </FormItem>
            </Grid>
            <Grid size={{ xs: 12, md: 6 }}>
              <FormItem
                label="Correo electrónico"
                helperText={uiState.emailError}
              >
                <OutlinedInput
                  fullWidth
                  value={uiState.email}
                  onChange={(e) => actions.onEmailChanged(e.target.value)}
                  error={!!uiState.emailError}
                />
              </FormItem>
            </Grid>
          </Grid>
        }
        footer={
          <Stack sx={{ flexDirection: 'row-reverse', p: '16px' }} gap={'16px'}>
            <Button
              variant="contained"
              disabled={uiState.saveDisabled}
              onClick={actions.onClickedSave}
            >
              Guardar cambios
            </Button>

            <Button
              variant="outlined"
              disabled={uiState.cancelDisabled}
              onClick={actions.onClickedCancel}
            >
              Cancelar
            </Button>
          </Stack>
        }
      />
    </Stack>
  );
}
